<script>
import { Bar } from 'vue-chartjs'

export default {
    name: 'DetailsHistoricalGraph',
    extends: Bar,
    props: {
        historicalRevenue: {
            type: Array,
            default: () => []
        },

        tasof: {
            type: String,
            default: () => ''
        }
    },

    data () {
        return {
            graphData: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: '#97C131',
                    barThickness: 40,
                }],
            },
            graphOptions: {
                plugins: {
                    labels: {
                        render: ({ value }) => {
                            return `${this.$options.filters.currency(value, false, false)}`
                        },
                        position: 'outside',
                        textMargin: 5,
                        fontFamily: "Sansation",
                        fontSize: 12,
                    },
                },
                maintainAspectRatio: false,
                responsive: true,
                layout: {
                    padding: {
                        top: 20,
                        bottom: 20,
                        left: 10,
                        right: 10,
                    },
                },
                legend: {
                    display: false,
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            display: false,
                            drawTicks: false,
                        },
                        ticks: {
                            padding: 10,
                            maxRotation: 0,
                        },
                    }],
                    yAxes: [{
                        display: false,
                        ticks: {
                            min: 0,
                        },
                    }],
                },
                tooltips: {
                    enabled: false,
                },
            },
        }
    },

    watch: {
        historicalRevenue: {
            handler () { this.formatData() },
            deep: true,
        },
    },

    mounted () {
        this.formatData()
    },

    methods: {
        formatData () {
            let revenues = this.historicalRevenue.slice()
                .sort(({ year: a }, { year: b }) => a - b)
            
            revenues = revenues.filter((rev) => rev.year !== 0)
            
            this.graphData.labels = revenues.map(({ year }) => year);
            this.graphData.datasets[0].data = revenues.map(({ revenue }) => revenue)
            
            this.renderChart(this.graphData, this.graphOptions)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/section-revenue/HistoricalGraph.vue